export default "__VITE_PUBLIC_ASSET__0fa71ef7__"